<template>
  <div style="font-size: 16px" class="header_container">
    <el-col :span="4">小程序票务后台管理  </el-col>
    <el-col :span="10">
    <el-select v-model="value" placeholder="请选择" @change="handleChange">
    <el-option
      v-for="item in siteData"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select></el-col>
    <div v-if="selectedSite">
      <p>当前选中的站点 ID: {{ selectedSite }}</p>
      <p>当前选中的站点名称: {{ getSelectedSiteName }}</p>
    </div>
  </div>
</template>


<script>
import $ from "jquery";

export default {
  data() {
    return {
      siteData:[],
      value:'',
      site_id:'',
       selectedSite: null
    }
  },
  created() {
       if (this.siteData.length === 0) {
      $.ajax({
        url: this.$settings.BASE_URL+'site/info',
        type: 'GET',
        dataType: 'json',
        data:{'login_from':'web'},
           xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('res777', res)
          if(res.info=='ok'){
            this.siteData = res.siteList
            this.value = res.siteList[0].name
            this.site_id = res.siteList[0].id
          }
            localStorage.setItem('selectedSite', this.selectedSite);
        },
        error: (error) => {
          console.log('请求失败：', error)
        }
      })
    }
  },
  computed: {
     getSelectedSiteName() {
      const selected = this.siteData.find(site => site.name === this.selectedSite);
      return selected ? selected.name : '';
    }
  },
  methods: {
   handleChange(newVal) {
      // 可以在这里做一些其他操作，例如将选择的数据发送到后端
      console.log('选中的站点 ID:', newVal);
    }
  },
}
</script>

<style lang="less">
@import '../style/mixin';

.header_container {
  background-color: #ffffff;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
}

.avator {
  .wh(36px, 36px);
  border-radius: 50%;
  margin-right: 37px;
}

.el-dropdown-menu__item {
  text-align: center;
}
</style>
